import React, { useState } from 'react';
import { Calendar, MapPin, Clock, Users, MessageSquare, Award, ArrowRight } from 'lucide-react';
import { Button } from '../components/UI/Button';
import { Link } from 'react-router-dom';
export const WarriEvent2025 = () => {
  const [activeTab, setActiveTab] = useState('details');
  const eventQuotes = ['Network and Grow', "Don't only use bridges, build them.", "Opportunities don't just knock—they're introduced through people.", 'Give, and Give; it comes back to you in greater measure.'];
  return <div className="pt-20 bg-white" data-id="element-4235">
      {/* Hero Section */}
      <section className="relative py-16 border-b border-gray-300" data-id="element-4236">
        <div className="absolute inset-0 z-0" data-id="element-4237">
          <div className="w-full h-full bg-gray-200 border-2 border-dashed border-gray-400" data-id="element-4238"></div>
        </div>
        <div className="container mx-auto px-4 relative z-10" data-id="element-4239">
          <div className="max-w-3xl mx-auto text-center" data-id="element-4240">
            <div className="inline-block bg-white border border-gray-300 px-4 py-1 rounded-md text-sm font-bold mb-6" data-id="element-4241">
              UPCOMING EVENT
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6" data-id="element-4242">
              Networking Salon: Warri Edition 2025
            </h1>
            <p className="text-xl text-gray-600 mb-8" data-id="element-4243">
              Connect with ambitious professionals in Warri and build meaningful
              relationships that unlock new opportunities.
            </p>
            <div className="flex flex-wrap justify-center gap-4" data-id="element-4244">
              <Button className="border-2 border-gray-800" data-id="element-4245">Register Now</Button>
              <Button variant="outline" className="border-2 border-gray-400" data-id="element-4246">
                Learn More
              </Button>
            </div>
          </div>
        </div>
      </section>
      {/* Event Details Section */}
      <section className="py-12 border-b border-gray-300" data-id="element-4247">
        <div className="container mx-auto px-4" data-id="element-4248">
          <div className="max-w-4xl mx-auto" data-id="element-4249">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-4250">
              <div className="border-2 border-gray-300 rounded-lg p-6 flex flex-col items-center text-center" data-id="element-4251">
                <div className="w-12 h-12 border-2 border-gray-400 rounded-full flex items-center justify-center mb-4" data-id="element-4252">
                  <Calendar size={24} className="text-gray-700" data-id="element-4253" />
                </div>
                <h3 className="text-lg font-bold text-gray-800 mb-2" data-id="element-4254">Date</h3>
                <p className="text-gray-600" data-id="element-4255">August 30, 2025</p>
              </div>
              <div className="border-2 border-gray-300 rounded-lg p-6 flex flex-col items-center text-center" data-id="element-4256">
                <div className="w-12 h-12 border-2 border-gray-400 rounded-full flex items-center justify-center mb-4" data-id="element-4257">
                  <MapPin size={24} className="text-gray-700" data-id="element-4258" />
                </div>
                <h3 className="text-lg font-bold text-gray-800 mb-2" data-id="element-4259">Venue</h3>
                <p className="text-gray-600" data-id="element-4260">Deluxe á la Carte Restaurant</p>
                <p className="text-gray-600" data-id="element-4261">Warri, Nigeria</p>
              </div>
              <div className="border-2 border-gray-300 rounded-lg p-6 flex flex-col items-center text-center" data-id="element-4262">
                <div className="w-12 h-12 border-2 border-gray-400 rounded-full flex items-center justify-center mb-4" data-id="element-4263">
                  <Clock size={24} className="text-gray-700" data-id="element-4264" />
                </div>
                <h3 className="text-lg font-bold text-gray-800 mb-2" data-id="element-4265">Time</h3>
                <p className="text-gray-600" data-id="element-4266">4:00 PM - 7:00 PM</p>
              </div>
            </div>
            <div className="border-2 border-gray-300 rounded-lg overflow-hidden mb-8" data-id="element-4267">
              <div className="flex border-b border-gray-300" data-id="element-4268">
                <button className={`px-6 py-3 font-medium ${activeTab === 'details' ? 'bg-gray-200 border-b-2 border-gray-800' : 'bg-white'}`} onClick={() => setActiveTab('details')} data-id="element-4269">
                  Event Details
                </button>
                <button className={`px-6 py-3 font-medium ${activeTab === 'agenda' ? 'bg-gray-200 border-b-2 border-gray-800' : 'bg-white'}`} onClick={() => setActiveTab('agenda')} data-id="element-4270">
                  Agenda
                </button>
                <button className={`px-6 py-3 font-medium ${activeTab === 'speakers' ? 'bg-gray-200 border-b-2 border-gray-800' : 'bg-white'}`} onClick={() => setActiveTab('speakers')} data-id="element-4271">
                  Speakers
                </button>
              </div>
              <div className="p-6" data-id="element-4272">
                {activeTab === 'details' && <div data-id="element-4273">
                    <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-4274">
                      About This Event
                    </h3>
                    <p className="text-gray-600 mb-4" data-id="element-4275">
                      Join us for an evening of meaningful connections,
                      inspiring conversations, and opportunities in Warri. The
                      Networking Salon brings together ambitious professionals,
                      entrepreneurs, and changemakers to build relationships
                      that matter.
                    </p>
                    <p className="text-gray-600 mb-4" data-id="element-4276">
                      This special edition will focus on creating strategic
                      connections among Warri's growing professional community,
                      with structured networking activities, curated
                      discussions, and opportunities to share ideas.
                    </p>
                    <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-4277">
                      <div className="border border-gray-300 rounded-lg p-4 flex items-start" data-id="element-4278">
                        <Users size={20} className="text-gray-700 mr-3 mt-1 flex-shrink-0" data-id="element-4279" />
                        <div data-id="element-4280">
                          <h4 className="font-bold text-gray-800 mb-1" data-id="element-4281">
                            Who Should Attend
                          </h4>
                          <p className="text-gray-600" data-id="element-4282">
                            Professionals, entrepreneurs, creatives, and
                            change-makers ages 18-45
                          </p>
                        </div>
                      </div>
                      <div className="border border-gray-300 rounded-lg p-4 flex items-start" data-id="element-4283">
                        <Award size={20} className="text-gray-700 mr-3 mt-1 flex-shrink-0" data-id="element-4284" />
                        <div data-id="element-4285">
                          <h4 className="font-bold text-gray-800 mb-1" data-id="element-4286">
                            What You'll Gain
                          </h4>
                          <p className="text-gray-600" data-id="element-4287">
                            Strategic connections, visibility, and access to
                            opportunities
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>}
                {activeTab === 'agenda' && <div data-id="element-4288">
                    <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-4289">
                      Event Agenda
                    </h3>
                    <div className="space-y-6" data-id="element-4290">
                      <div className="border-l-2 border-gray-300 pl-4 ml-4" data-id="element-4291">
                        <div className="flex items-center mb-2" data-id="element-4292">
                          <div className="w-8 h-8 bg-gray-200 border border-gray-300 rounded-full flex items-center justify-center -ml-8 mr-2" data-id="element-4293">
                            <span className="text-gray-700 font-bold" data-id="element-4294">1</span>
                          </div>
                          <h4 className="font-bold text-gray-800" data-id="element-4295">
                            4:00 PM - 4:30 PM: Registration & Welcome
                          </h4>
                        </div>
                        <p className="text-gray-600 ml-2" data-id="element-4296">
                          Check-in, receive your name tag, and enjoy welcome
                          refreshments
                        </p>
                      </div>
                      <div className="border-l-2 border-gray-300 pl-4 ml-4" data-id="element-4297">
                        <div className="flex items-center mb-2" data-id="element-4298">
                          <div className="w-8 h-8 bg-gray-200 border border-gray-300 rounded-full flex items-center justify-center -ml-8 mr-2" data-id="element-4299">
                            <span className="text-gray-700 font-bold" data-id="element-4300">2</span>
                          </div>
                          <h4 className="font-bold text-gray-800" data-id="element-4301">
                            4:30 PM - 5:00 PM: Keynote Session
                          </h4>
                        </div>
                        <p className="text-gray-600 ml-2" data-id="element-4302">
                          Opening remarks and keynote presentation on building
                          powerful networks
                        </p>
                      </div>
                      <div className="border-l-2 border-gray-300 pl-4 ml-4" data-id="element-4303">
                        <div className="flex items-center mb-2" data-id="element-4304">
                          <div className="w-8 h-8 bg-gray-200 border border-gray-300 rounded-full flex items-center justify-center -ml-8 mr-2" data-id="element-4305">
                            <span className="text-gray-700 font-bold" data-id="element-4306">3</span>
                          </div>
                          <h4 className="font-bold text-gray-800" data-id="element-4307">
                            5:00 PM - 6:00 PM: Structured Networking
                          </h4>
                        </div>
                        <p className="text-gray-600 ml-2" data-id="element-4308">
                          Guided networking activities designed to create
                          meaningful connections
                        </p>
                      </div>
                      <div className="border-l-2 border-gray-300 pl-4 ml-4" data-id="element-4309">
                        <div className="flex items-center mb-2" data-id="element-4310">
                          <div className="w-8 h-8 bg-gray-200 border border-gray-300 rounded-full flex items-center justify-center -ml-8 mr-2" data-id="element-4311">
                            <span className="text-gray-700 font-bold" data-id="element-4312">4</span>
                          </div>
                          <h4 className="font-bold text-gray-800" data-id="element-4313">
                            6:00 PM - 6:45 PM: Panel Discussion
                          </h4>
                        </div>
                        <p className="text-gray-600 ml-2" data-id="element-4314">
                          Industry leaders share insights on opportunities in
                          Warri and beyond
                        </p>
                      </div>
                      <div className="border-l-2 border-gray-300 pl-4 ml-4" data-id="element-4315">
                        <div className="flex items-center mb-2" data-id="element-4316">
                          <div className="w-8 h-8 bg-gray-200 border border-gray-300 rounded-full flex items-center justify-center -ml-8 mr-2" data-id="element-4317">
                            <span className="text-gray-700 font-bold" data-id="element-4318">5</span>
                          </div>
                          <h4 className="font-bold text-gray-800" data-id="element-4319">
                            6:45 PM - 7:00 PM: Closing & Next Steps
                          </h4>
                        </div>
                        <p className="text-gray-600 ml-2" data-id="element-4320">
                          Wrap-up, next steps, and information about future
                          events
                        </p>
                      </div>
                    </div>
                  </div>}
                {activeTab === 'speakers' && <div data-id="element-4321">
                    <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-4322">
                      Featured Speakers
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-4323">
                      <div className="flex items-center border border-gray-300 rounded-lg p-4" data-id="element-4324">
                        <div className="w-20 h-20 bg-gray-200 border-2 border-dashed border-gray-400 rounded-full mr-4 flex-shrink-0" data-id="element-4325"></div>
                        <div data-id="element-4326">
                          <h4 className="font-bold text-gray-800" data-id="element-4327">
                            Andrew Igbineweka
                          </h4>
                          <p className="text-gray-600" data-id="element-4328">
                            Founder, The Networking Salon
                          </p>
                        </div>
                      </div>
                      <div className="flex items-center border border-gray-300 rounded-lg p-4" data-id="element-4329">
                        <div className="w-20 h-20 bg-gray-200 border-2 border-dashed border-gray-400 rounded-full mr-4 flex-shrink-0" data-id="element-4330"></div>
                        <div data-id="element-4331">
                          <h4 className="font-bold text-gray-800" data-id="element-4332">
                            Local Lead
                          </h4>
                          <p className="text-gray-600" data-id="element-4333">Warri City Ambassador</p>
                        </div>
                      </div>
                      <div className="flex items-center border border-gray-300 rounded-lg p-4" data-id="element-4334">
                        <div className="w-20 h-20 bg-gray-200 border-2 border-dashed border-gray-400 rounded-full mr-4 flex-shrink-0" data-id="element-4335"></div>
                        <div data-id="element-4336">
                          <h4 className="font-bold text-gray-800" data-id="element-4337">
                            Guest Speaker
                          </h4>
                          <p className="text-gray-600" data-id="element-4338">Industry Expert</p>
                        </div>
                      </div>
                      <div className="flex items-center border border-gray-300 rounded-lg p-4" data-id="element-4339">
                        <div className="w-20 h-20 bg-gray-200 border-2 border-dashed border-gray-400 rounded-full mr-4 flex-shrink-0" data-id="element-4340"></div>
                        <div data-id="element-4341">
                          <h4 className="font-bold text-gray-800" data-id="element-4342">
                            Panel Moderator
                          </h4>
                          <p className="text-gray-600" data-id="element-4343">Community Leader</p>
                        </div>
                      </div>
                    </div>
                  </div>}
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Event Highlights */}
      <section className="py-12 border-b border-gray-300" data-id="element-4344">
        <div className="container mx-auto px-4" data-id="element-4345">
          <h2 className="text-2xl font-bold text-center text-gray-800 mb-8" data-id="element-4346">
            Event Highlights
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-4347">
            <div className="relative aspect-[4/3] border-2 border-dashed border-gray-400 rounded-lg overflow-hidden" data-id="element-4348">
              <div className="absolute inset-0 bg-gray-100 flex items-center justify-center" data-id="element-4349">
                <div className="w-16 h-16 border-2 border-gray-400 rounded-full flex items-center justify-center" data-id="element-4350">
                  <MessageSquare size={32} className="text-gray-500" data-id="element-4351" />
                </div>
              </div>
            </div>
            <div data-id="element-4352">
              <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-4353">
                Inspiring Conversations
              </h3>
              <div className="space-y-4" data-id="element-4354">
                {eventQuotes.map((quote, index) => <div key={index} className="border-l-2 border-gray-400 pl-4" data-id="element-4355">
                    <p className="text-gray-700 font-medium" data-id="element-4356">{quote}</p>
                  </div>)}
              </div>
              <div className="mt-6" data-id="element-4357">
                <p className="text-gray-600" data-id="element-4358">
                  Join us at Deluxe á la Carte Restaurant in Warri for an
                  evening of meaningful networking and inspiration. Connect with
                  like-minded professionals and discover new opportunities.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Registration Section */}
      <section className="py-12 border-b border-gray-300 bg-gray-50" data-id="element-4359">
        <div className="container mx-auto px-4" data-id="element-4360">
          <div className="max-w-3xl mx-auto text-center" data-id="element-4361">
            <h2 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-4362">
              Secure Your Spot
            </h2>
            <p className="text-gray-600 mb-8" data-id="element-4363">
              Limited seats available. Register now to join The Networking Salon
              Warri Edition.
            </p>
            <div className="border-2 border-gray-300 rounded-lg p-6 bg-white mb-8" data-id="element-4364">
              <div className="flex justify-center mb-6" data-id="element-4365">
                <div className="w-16 h-16 border-2 border-gray-400 rounded-full flex items-center justify-center" data-id="element-4366">
                  <Award size={32} className="text-gray-700" data-id="element-4367" />
                </div>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-4368">
                Event Registration
              </h3>
              <div className="text-center mb-6" data-id="element-4369">
                <p className="text-3xl font-bold text-gray-800" data-id="element-4370">₦5,000</p>
                <p className="text-gray-600" data-id="element-4371">per person</p>
              </div>
              <ul className="space-y-3 mb-8 text-left max-w-md mx-auto" data-id="element-4372">
                <li className="flex items-start" data-id="element-4373">
                  <div className="w-5 h-5 rounded-full border border-gray-400 flex items-center justify-center mr-2 mt-0.5" data-id="element-4374">
                    <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4375"></div>
                  </div>
                  <span className="text-gray-600" data-id="element-4376">
                    Full access to the networking event
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4377">
                  <div className="w-5 h-5 rounded-full border border-gray-400 flex items-center justify-center mr-2 mt-0.5" data-id="element-4378">
                    <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4379"></div>
                  </div>
                  <span className="text-gray-600" data-id="element-4380">Refreshments and dinner</span>
                </li>
                <li className="flex items-start" data-id="element-4381">
                  <div className="w-5 h-5 rounded-full border border-gray-400 flex items-center justify-center mr-2 mt-0.5" data-id="element-4382">
                    <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4383"></div>
                  </div>
                  <span className="text-gray-600" data-id="element-4384">
                    Professional networking materials
                  </span>
                </li>
                <li className="flex items-start" data-id="element-4385">
                  <div className="w-5 h-5 rounded-full border border-gray-400 flex items-center justify-center mr-2 mt-0.5" data-id="element-4386">
                    <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4387"></div>
                  </div>
                  <span className="text-gray-600" data-id="element-4388">
                    Access to post-event connections
                  </span>
                </li>
              </ul>
              <Button className="w-full border-2 border-gray-800" data-id="element-4389">
                Register Now
              </Button>
            </div>
            <p className="text-gray-600" data-id="element-4390">
              Inner Circle members receive a special discount.
              <Link to="/membership" className="underline ml-1" data-id="element-4391">
                Learn more about membership
              </Link>
            </p>
          </div>
        </div>
      </section>
      {/* Location Map */}
      <section className="py-12" data-id="element-4392">
        <div className="container mx-auto px-4" data-id="element-4393">
          <h2 className="text-2xl font-bold text-center text-gray-800 mb-8" data-id="element-4394">
            Event Location
          </h2>
          <div className="max-w-4xl mx-auto" data-id="element-4395">
            <div className="aspect-[16/9] border-2 border-gray-300 rounded-lg overflow-hidden mb-6" data-id="element-4396">
              <div className="w-full h-full bg-gray-200 flex items-center justify-center" data-id="element-4397">
                <div className="text-center" data-id="element-4398">
                  <MapPin size={48} className="text-gray-400 mx-auto mb-2" data-id="element-4399" />
                  <p className="text-gray-600" data-id="element-4400">
                    Map of Deluxe á la Carte Restaurant, Warri
                  </p>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-4401">
              <div className="border-2 border-gray-300 rounded-lg p-6" data-id="element-4402">
                <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-4403">
                  Venue Details
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-4404">
                  <strong data-id="element-4405">Deluxe á la Carte Restaurant</strong>
                  <br data-id="element-4406" />
                  Warri, Delta State, Nigeria
                </p>
                <p className="text-gray-600" data-id="element-4407">
                  A premium dining venue with excellent facilities for
                  networking events. The restaurant offers a comfortable
                  atmosphere conducive to meaningful conversations and
                  connections.
                </p>
              </div>
              <div className="border-2 border-gray-300 rounded-lg p-6" data-id="element-4408">
                <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-4409">
                  Contact Information
                </h3>
                <div className="space-y-4" data-id="element-4410">
                  <p className="text-gray-600" data-id="element-4411">
                    <strong data-id="element-4412">Event Coordinator:</strong>
                    <br data-id="element-4413" />
                    The Networking Salon Team
                    <br data-id="element-4414" />
                    info@thenetworkingsalon.live
                  </p>
                  <p className="text-gray-600" data-id="element-4415">
                    <strong data-id="element-4416">Local Lead:</strong>
                    <br data-id="element-4417" />
                    Warri City Ambassador
                    <br data-id="element-4418" />
                    warri@thenetworkingsalon.live
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Final CTA */}
      <section className="py-16 bg-gray-50" data-id="element-4419">
        <div className="container mx-auto px-4 text-center" data-id="element-4420">
          <h2 className="text-3xl font-bold text-gray-800 mb-8 max-w-2xl mx-auto" data-id="element-4421">
            Join Us in Warri to Build Connections That Matter
          </h2>
          <Button className="border-2 border-gray-800" data-id="element-4422">
            Register for the Event
            <ArrowRight size={16} className="ml-2" data-id="element-4423" />
          </Button>
        </div>
      </section>
    </div>;
};